<template>
	<div class="leftPart">
		<div class="left1 itemPart">
			<div class="title">
				<span class="titleIcon titleShaw">
					数据总览
				</span>
			</div>
			<div class="contBox">
				<div class="itemBox sbsl">
					<!-- <div class=""></div> -->
					<div class="numBox">
						<p class="numLabel">设备数量 ( 座 )</p>
						<p class="numValue">{{dataObj.num1}}</p>
					</div>
				</div>
				<div class="itemBox yhsl">
					<!-- <div class=""></div> -->
					<div class="numBox">
						<p class="numLabel">用户数量 ( 户 )</p>
						<p class="numValue">{{dataObj.num2}}</p>
					</div>
				</div>
				<div class="itemBox ljfwl">
					<!-- <div class="ljfwl"></div> -->
					<div class="numBox">
						<p class="numLabel">累计服务量 ( 次 )</p>
						<p class="numValue">{{dataObj.num3}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="left2 itemPart">
			<div class="title">
				<span class="titleIcon titleShaw">
					安全性分析
				</span>
			</div>
			<div class="contBox">
				<div class="contTitle disCenter">安全性综合评分 <span>{{dataObj.score}}</span></div>
				<div class="contLine"></div>
				<div class="contCircle disCenter">
					<span>{{dataObj.score}}</span>
				</div>
				<div class="contText">
					<div class="contTextItem disCenter">过压保护</div>
					<div class="contTextItem disCenter">过流保护</div>
					<div class="contTextItem disCenter">短路保护</div>
					<div class="contTextItem disCenter">漏电保护</div>
				</div>
			</div>
		</div>
		<div class="left3 itemPart">
			<div class="contText">
				<div class="contTitle">智能升级 安全强化</div>
			</div>
		</div>
		<!-- <div class="left4">
			<div class="title">
				<span class="titleIcon titleShaw">
					绿色效益
				</span>
			</div>
			<div class="contText">
				<div class="contTop disAround">
					<div class="contLeft"></div>
					<div class="contRight">
						<p class="contTitle">累计减少碳排量</p>
						<p class="contValue">
							<span class="numBox">{{dataObj.num4}}</span>
							<span>万</span>
							<span>吨CO₂</span>
						</p>
					</div>
				</div>
				<div class="contBot">
					电动车使用每度电可以减少
					<span>{{dataObj.num5}}</span>
					碳排量
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
	export default {
		name: 'leftPart',
		data() {
			return {
				dataObj: {
					num1: '-',
					num2: '-',
					num3: '-',
					score: '-',
					num4: '-',
					num5: '-'
				},
				timerL: null
			}
		},
		mounted() {
			this.getdata()
			this.getdataView()
			this.timerL = setInterval(() => {
				this.dataObj.num2 += Math.ceil(Math.random() * 3)
				this.dataObj.num3 += Math.ceil(Math.random() * 10)
			}, 30000)
		},
		methods: {
			getdataView() {
				this.$api.dataView({}).then(res => {
					console.log(res)
					this.dataObj.num1 = res.obj.equipmentNumber
					this.dataObj.num2 = res.obj.userNumber
					this.dataObj.num3 = res.obj.serviceNumber

				}).catch(function(error) {
					console.log(error);
				});
			},
			getdata() {
				this.$api.greenBenefit({}).then(res => {
					console.log(res)
					this.dataObj.num4 = res.obj.carbonNumber
					this.dataObj.num5 = res.obj.carbonUnit
					this.dataObj.score = res.obj.avgScore

				}).catch(function(error) {
					console.log(error);
				});

			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "leftPart.scss"
</style>